import React from 'react';

import useColors from 'hooks/use-colors';

function SvgDutchieWordmark(props) {
  const colors = useColors();
  return (
    <svg viewBox='0 0 90.3 19.3' fill={colors.v2Green} {...props}>
      <title>dutchie</title>
      <g>
        {/* eslint-disable-next-line max-len */}
        <path d='M9.8 6.7c-1-1-2.3-1.6-3.8-1.6-3.6 0-6 2.8-6 7.1s2.4 7.1 6 7.1c1.5 0 2.7-.5 3.8-1.6V19h4V.5h-4zm-2.7 2c1 0 2.2.5 2.7 1.3v4.5c-.5.8-1.7 1.3-2.7 1.3-1.8 0-3.1-1.4-3.1-3.6 0-2.1 1.3-3.5 3.1-3.5zM25.5 14.5c-.3.4-1.3 1.3-2.7 1.3-1.5 0-2.2-.6-2.2-2.2V5.5h-3.9V15c0 2.8 1.6 4.4 4.5 4.4 2.1 0 3.6-.9 4.3-1.6V19h3.9V5.5h-3.9zM38.9 15.5c-.1.2-.6.3-1 .3-.7 0-.9-.6-.9-1.2V9h2.6V5.5H37V1.9h-4v3.6h-2.2V9H33v6.5c0 2.5 1.4 3.8 3.9 3.8 1.7 0 2.6-.5 3-.9l.1-.1-.9-3.2zM47.9 8.7c1.1 0 2 .4 2.5 1.3l.2.2 2.6-2.5-.1-.2c-.7-.9-2.2-2.5-5.4-2.5-4.1 0-7.2 3-7.2 7.1s3 7.1 7.2 7.1c3.1 0 4.7-1.6 5.4-2.5l.1-.2-2.6-2.5-.2.2c-.6.9-1.5 1.3-2.5 1.3-2 0-3.3-1.4-3.3-3.6 0-1.8 1.3-3.2 3.3-3.2zM63.2 5.2c-2.1 0-3.6 1-4.3 1.6V.5h-4V19h4v-9c.3-.4 1.2-1.3 2.7-1.3s2.2.6 2.2 2.1V19h3.9V9.5c-.1-2.8-1.6-4.3-4.5-4.3zM72.5 0c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3zM70.5 5.5h3.9V19h-3.9zM90.3 12.6c0-4.4-2.7-7.4-6.8-7.4-4 0-7 3-7 7.1 0 4.2 3 7.1 7.2 7.1 2.2 0 4.3-.7 5.5-1.9l.2-.1-1.8-2.7-.2.2c-.8.8-2.3 1.2-3.3 1.2-1.8 0-3.1-.9-3.4-2.4h9.6zm-6.8-4.1c1.9 0 2.8 1.1 3 2.3h-5.8c.2-1.2 1-2.3 2.8-2.3z' />
      </g>
    </svg>
  );
}

export default SvgDutchieWordmark;
